<template>
  <section id="startup">
    <StartupHeader
      class="header"
      :closeSidepanel="closeSidepanel"
      :onePager="selectedStartup.one_pager"
      :web="selectedStartup.website"
      :name="selectedStartup.name"
      :logo="selectedStartup.logo"
    />

    <div class="container main">
      <div class="col-12">
        <div class="row">
          <div class="col-4 item-data">
            <h4>Valuación (U$D)</h4>
            <p>{{numberWithDots(selectedStartup.basic.valuacion)}}</p>
          </div>
          <div class="col-5 item-data">
            <h4>Total invertido (U$D)</h4>
            <p>{{numberWithDots(totalInvested)}}</p>
          </div>
          <div class="col-3 item-data" style="padding-left: 7px;" v-if="gridxPercentage">
            <h4>GRIDX {{fund}}</h4>
            <p>{{gridxPercentage}}%</p>
          </div>
        </div>
      </div>

      <div class="col-12 status" v-show="statusCards.length">
        <StatusCardDisplayer :cards="statusCards" />
      </div>

      <div class="col-12 tabs" v-if="showTabs">
        <Tabs title="Información">
          <md-tab id="tab-home" md-label="General">
            <StartupGeneralInfo
              :verticales="selectedStartup.verticales"
              :employees="selectedStartup.basic.empleados"
              :founders="selectedStartup.founders"
              :description="selectedStartup.description"
            />
          </md-tab>

          <md-tab id="tab-pages" md-label="Inversión">
            <StartupInvestmentInfo
              :invested="invested"
              :externalInvested="external"
              :followOn="selectedFondo === 'GRIDX' ? selectedStartup.basic.invertido_gridx_follow : selectedStartup.basic.invertido_gridx_2_follow"
              :constitutionDate="selectedStartup.fecha_constitucion"
              :batch="selectedStartup.basic.batch"
              :principalInvestors="selectedStartup.basic.inversores"
              :fondce="selectedStartup.fondice"
            />
          </md-tab>

          <md-tab id="tab-posts" md-label="Documentos" v-if="startupDocuments.length > 0">
            <StartupDocumentsInfo
              :otherDocuments="startupDocuments"
              :statute="this.selectedStartup.basic.estatuto"
              :reformsStatute="this.selectedStartup.basic.reformas_estatuto"
              :initialActionsRegister="this.selectedStartup.basic.registro_acciones_inicial"
            />
          </md-tab>

          <md-tab id="tab-press" md-label="Prensa" v-if="pressDocuments.length > 0">
            <StartupPress :documents="pressDocuments" />
          </md-tab>
        </Tabs>
      </div>
    </div>
  </section>
</template>

<script>
import StartupHeader from './StartupHeader.vue';
import StatusCardDisplayer from './StatusCardDisplayer.vue';
import Tabs from './Tabs.vue';
import StartupGeneralInfo from './StartupGeneralInfo.vue';
import StartupInvestmentInfo from './StartupInvestmentInfo.vue';
import StartupDocumentsInfo from './StartupDocumentsInfo.vue';
import StartupPress from './StartupPress.vue';
import { numberWithDots } from '../helpers/numbers';

export default {
  name: 'StartupDetails',
  components: {
    StartupHeader,
    StatusCardDisplayer,
    Tabs,
    StartupGeneralInfo,
    StartupInvestmentInfo,
    StartupDocumentsInfo,
    StartupPress,
  },
  props: {
    closeSidepanel: Function,
    selectedStartup: Object,
  },
  computed: {
    external() {
      if(this.selectedFondo === 'GRIDX2') {
        return this.selectedStartup.basic.inversion_externa + this.selectedStartup.basic.invertido_gridx + this.selectedStartup.basic.invertido_gridx_follow;
      }

      return this.selectedStartup.basic.inversion_externa + this.selectedStartup.basic.invertido_gridx_2 + this.selectedStartup.basic.invertido_gridx_2_follow;
    },
    selectedFondo() {
      return this.$store.state.selectedFondo;
    },
    fund() {
      if(this.selectedFondo === 'GRIDX2') return 'Fund II';
      return 'Fund I';
    },
    invested() {
      return this.selectedStartup.basic[this.fondos[this.selectedFondo]];
    },
    totalInvested(){
      return this.selectedStartup.basic.invertido_gridx
        + this.selectedStartup.basic.invertido_gridx_follow
        + this.selectedStartup.basic.invertido_gridx_2
        + this.selectedStartup.basic.invertido_gridx_2_follow
        + this.selectedStartup.basic.inversion_externa;
    },
    statusCards() {
      return [...this.selectedStartup.status].sort((a, b) => b.id - a.id);
    },
    startupDocuments() {
      return this.selectedStartup.documentos.filter((x) => x.type !== 'Prensa');
    },
    pressDocuments() {
      return this.selectedStartup.documentos.filter((x) => x.type === 'Prensa');
    },
    gridxPercentage(){
      let gridxInvestor = null;

      if(this.selectedFondo === 'GRIDX2') {
        gridxInvestor = this.selectedStartup.basic.inversores.find(x => x.name.toUpperCase() === 'GridX - Fund II'.toUpperCase());
      } else {
        gridxInvestor = this.selectedStartup.basic.inversores.find(x => x.name.toUpperCase() === 'GridX'.toUpperCase());
      }

      return gridxInvestor ? gridxInvestor.porcentaje_participacion : null;
    },
  },
  watch: {
    startupDocuments() {
      this.showTabs = false;
    },
    showTabs(value){
      if(!value){
        setTimeout(() => {
         this.showTabs = true;
      }, 10);
      }
    },
  },
  data() {
    return {
      numberWithDots,
      showTabs: true,
      fondos: {
        GRIDX: 'invertido_gridx',
        GRIDX2: 'invertido_gridx_2',
      }
    };
  },
};
</script>

<style scoped lang="scss">
#startup {
  min-height: 100vh;
  background: #f9f6fc;
  padding-bottom: 50px;

  @media (min-width: 768px) {
    background: #fff;
  }
}
.item-data {
  margin-top: 15px;
  padding-right: 0;

  h4 {
    font-size: 9px;
    color: #979797;
    margin: 0;
    font-weight: 300;
    line-height: 2;
    @media (min-width: 373px) {
      font-size: 11px;
    }
  }
  p {
    font-size: 18px;
    color: #330e2f;
    margin: 0;
    font-weight: 600;
  }
}
.status,
.tabs {
  margin-top: 30px;
}
</style>
